module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'export default __webpack_public_path__ + "scripts/templates/250mL-Flask-Stopper-selection.svg";';

}
return __p
}